import { ListenerPayload } from '@optimizely/optimizely-sdk';

export enum Flags {
  FORCE_CLOSED = 'life-growth_operations_force-closed',
  BANNER_DSS_FLOW_ENABLED = 'life-consumer_operations_banner-dss-enabled',
  HIDE_CALENDLY = 'life-consumer_operations_disable-calendly',
  ADD_TOTAL_HOUSEHOLD_INCOME = 'households_add_total_househould_income',
  ADDITIONAL_CARRIER_DETAILS = 'life-consumer_release_additional_carrier_details',
  EMPLOYMENT_PAGE = 'life-consumer_release_employment_page',
  BANNER_BIRTHPLACE_PAGE = 'life-consumer_release_banner-birthplace-page',
  HAZARDOUS_EMPLOYMENT_QUESTIONS = 'life_consumer_release__hazardous_employment_questions',
  BANNER_SSN_QUESTION = 'life_consumer_release__banner_ssn_question',
  BANNER_APPLICATION_HISTORY_QUESTION = 'life_consumer_release_banner_application_history_question',
  BANNER_DRIVER_HISTORY_PAGE = 'life_consumer_release_banner_driving_history_page',
  BANNER_ALCOHOL_HISTORY_PAGE = 'life_consumer_release_banner_alcohol_history_page',
  ASTHMA_DIABETES_CO_INCLUSION = 'life-consumer_release_asthma-diabetes-co-inclusion',
  SPOUSAL_INTENT_SKIP_BANNER_D2D = 'life-consumer_release_spousal_intent_skip_banner_d2d',
  DISABLE_LGA_DIGITAL_APPLY = 'life-consumer_release_disable_lga_digital_apply',
  LIFE_FUNNEL_REMIX_P2 = 'life-consumer_life_funnel_remix_p2',
  DIGITAL_EXPERIMENT_PREMIUM_PROTECTORS = 'life-digital_experiment_premium-protector-disable-digital', // MLD-90 - Remove if premium protectors A/B test fails
  SPOUSAL_SELF_SERVE = 'life-digital_experiment_spousal-self-serve', // MLD-1 - Remove if Life Spousal Self Serve loses
  MANUAL_DIALER_ADD_FOR_DIGITAL_INELIGIBLE_CUSTOMERS = 'life-digital_manual_dialer_add_for_digital_ineligible_customers',
  OLDER_SEGMENT_INTELLIGENT_ROUTING_EXPERIMENT = 'life-digital_experiment_intelligent-routing-older-segment', // MLD-67 - Remove if Older Segment Intelligent Routing Loses
  OFFBOARD_PARTNER_REFERRAL_TRAFFIC = 'life-digital_experiment_offboard-partner-referral-traffic',
}

interface FlagDecisionInfo {
  flagKey: string;
  enabled: boolean;
  variationKey: string;
  ruleKey: string;
  variables: Record<string, unknown>;
  reasons: string[];
  decisionEventDispatched: boolean;
}

interface FeatureDecisionInfo {
  featureKey: string;
  featureEnabled: boolean;
  source: string;
  sourceInfo: Record<string, unknown>;
}
interface FlagDecisionListener extends ListenerPayload {
  type: 'flag';
  decisionInfo: FlagDecisionInfo;
}

interface FeatureDecisionInfo {
  featureKey: string;
  featureEnabled: boolean;
  source: string;
  sourceInfo: Record<string, unknown>;
}

interface FeatureDecisionListener extends ListenerPayload {
  type: 'feature';
  decisionInfo: FeatureDecisionInfo;
}

export type DecisionListener = FlagDecisionListener | FeatureDecisionListener;
